// extracted by mini-css-extract-plugin
module.exports = {"subHeaderContainer":"TopArea-subHeaderContainer-3NDN6w","searchContainer":"TopArea-searchContainer-3cgGOv"};